import { isNumber } from 'lodash'

import { getActivity, getActivities } from '../lib/APIClient'
import createDuck from '../lib/MetagnosticDuck'
import { getText } from '../lib/text'
import emptyActivity from '../lib/emptyActivity'

/**
 *
 */

const rehydrate = a  => {
  const aa = { ...emptyActivity, ...a }
  if (!isNumber(aa.price.general)) aa.price.general = Number.parseFloat(aa.price.general)
  if (!isNumber(aa.duration)) aa.duration = Number(aa.duration) || Number.parseFloat(aa.duration)
  if (aa.creation && !aa.modification) aa.modification = aa.creation

  if (aa.description === getText("Descripción *vacía*")) aa.description = ""
  if (aa.longDescription === getText("Descripción larga *vacía*")) aa.longDescription = ""
  if (aa.notes === getText("Notas vacías")) aa.notes = ""

  aa.files = { ...emptyActivity.files, ...a.files }
  aa.voucherFiles = { ...emptyActivity.voucherFiles, ...a.voucherFiles }

  return aa
}

/**
 *
 */

const duck = createDuck(
  "ACTIVITIES",
  getActivity,
  getActivities,
  { },
  emptyActivity,
  null,
  { customRehydrate: rehydrate }
)

export const createActivity = duck.actions.createDoc
export const receiveActivities = duck.actions.receiveCollection
export const receiveActivity = duck.actions.receiveDoc
export const removeActivity = duck.actions.removeDoc
export const fetchActivities = duck.actions.fetchCollection
export const updateActivity = duck.actions.updateDoc

export default duck
